import { Box, Text, } from '@chakra-ui/react';
import React from 'react';

const PreviewExpertise = ({ questions }) => {
  return (
    <Box className="contentBox expertise">
        {questions !== undefined && questions['TSQ5'] !== undefined && Object.values(questions['TSQ5'].answer).map((ans) => {
          return (
            <Text className='skill'>{ans}</Text>
          );
        })}
    </Box>
  );
}
  export default PreviewExpertise;

